
/**
 * Waits at least for a set amout of milliseconds before resolving promise
 */
export async function thenWait<T>(ms: number, promise: Promise<T>): Promise<T> {
    const res = await Promise.all([ promise, wait(ms) ]);

    return res[0];
}

/**
 * Creates a promise that waits for a set amount of milliseconds
 */
export function wait(ms: number): Promise<void> {
    return new Promise(resolve => {
        setTimeout(() => resolve(), ms);
    });
}
